import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { IContents } from "interfaces";

const { Title, Text } = Typography;

export const ContentsShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IContents>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Chave</Title>
      <Text>{record?.key}</Text>

      <Title level={5}>Valor</Title>
      <Text>{record?.value}</Text>
    </Show>
  );
};
